import React from 'react';
import { SearchInput } from '@features/SearchInput';
import { useAchRelationshipsTable } from '../../lib';
import './AchRelationshipsTableFilters.scss';

export const AchRelationshipsTableFilters: React.FC = () => {
    const { setAlias } = useAchRelationshipsTable();

    return (
        <div className='widget-ach-relationships-table-filters'>
            <SearchInput
                setValue={setAlias}
                queryName='alias'
                placeholder='Alias'
            />
        </div>
    );
};
